// extracted by mini-css-extract-plugin
module.exports = {"hideScrollbar":"hero_hideScrollbar__led_P"};